module.exports = __webpack_public_path__ + "img/TIMES.614ea059.svg";